var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',[_vm._l((_vm.list),function(el){return [_c('uploadImg',{key:el.id,ref:"image",refInFor:true,attrs:{"src":el.url},on:{"removeSrc":function($event){return _vm.remove(el)}}})]})],2),_c('i',{staticClass:"el-icon-circle-plus-outline addIcon",on:{"click":_vm.add}})])
}
var staticRenderFns = []

export { render, staticRenderFns }